module.exports = __webpack_public_path__ + "img/DashboardHero.30886740.svg";